import { doc, getDoc, setDoc, getDocs, collection } from 'firebase/firestore';
import { firestore } from '../services/firebase';
import { firestoreAutoId } from '../utils/validators';
import { getStorage, ref as storageRef, getMetadata, updateMetadata } from "firebase/storage";

/**
 * Copia um módulo de conteúdo (card) de uma categoria para outra.
 *
 * @param {string} sourceCategoryId - ID da categoria de origem.
 * @param {string} sourceCardId - ID do módulo (card) a ser copiado.
 * @param {string} destinationCategoryId - ID da categoria de destino.
 */

export async function copyModule(sourceCategoryId, sourceCardId, destinationCategoryId) {
  console.log("cheguei aqui");
  console.log("sourceCategoryId", sourceCategoryId);
  console.log("sourceCardId", sourceCardId);
  console.log("destinationCategoryId", destinationCategoryId);

  try {
    // 1) Obter dados do módulo original
    const sourceModuleRef = doc(firestore, 'categories', sourceCategoryId, 'cards', sourceCardId);
    const sourceModuleSnap = await getDoc(sourceModuleRef);
    if (!sourceModuleSnap.exists()) {
      throw new Error('Módulo não encontrado.');
    }
    const moduleData = sourceModuleSnap.data();

    // 2) Preparar e criar novo módulo (sempre archived: true)
    const newModuleData = { ...moduleData, archived: true };
    const newCardId = firestoreAutoId();
    const destinationModuleRef = doc(firestore, 'categories', destinationCategoryId, 'cards', newCardId);
    await setDoc(destinationModuleRef, newModuleData, { merge: true });
    console.log("criei o card novo", newCardId);

    // 3) Copiar vídeos E atualizar metadados de cada página
    const videosCollectionRef = collection(
      firestore,
      'categories',
      sourceCategoryId,
      'cards',
      sourceCardId,
      'videos'
    );
    const videosQuerySnapshot = await getDocs(videosCollectionRef);

    const storage = getStorage();
    // helper extraído para uso interno
    async function safeUpdateMetadata(path, refs) {
      console.log(`\n[safeUpdate] iniciando para: "${path}"`);
      try {
        const fileRef = storageRef(storage, path);
        const meta = await getMetadata(fileRef);
        const existingCustom = meta.customMetadata || {};
        const usos = existingCustom.usages ? JSON.parse(existingCustom.usages) : [];

        const exists = r =>
          usos.some(u =>
            u.categoryId === r.categoryId &&
            u.cardId === r.cardId &&
            u.videoId === r.videoId
          );

        refs.forEach(r => {
          if (!exists(r)) {
            usos.push(r);
            console.log('[safeUpdate] adicionou ref:', r);
          }
        });

        const newCustom = {
          ...existingCustom,
          usages: JSON.stringify(usos),
        };
        await updateMetadata(fileRef, { customMetadata: newCustom });
        console.log(`[safeUpdate] updateMetadata OK para "${path}"`);
      } catch (err) {
        console.error(`[safeUpdate] ERRO em "${path}":`, err);
      }
    }

    // copiar cada vídeo e atualizar seus arquivos clicando nos refs adequados
    for (const videoDoc of videosQuerySnapshot.docs) {
      const videoData = videoDoc.data();
      console.log("busquei os videos", videoData);

      const newVideoId = firestoreAutoId();
      const destPageRef = doc(
        firestore,
        'categories',
        destinationCategoryId,
        'cards',
        newCardId,
        'videos',
        newVideoId
      );
      await setDoc(destPageRef, videoData, { merge: true });

      // prepara refs para esta página
      const sourceRef = {
        categoryId: sourceCategoryId,
        cardId: sourceCardId,
        videoId: videoDoc.id
      };
      const destRef = {
        categoryId: destinationCategoryId,
        cardId: newCardId,
        videoId: newVideoId
      };

      // 3.1) thumb da página
      if (videoData.backgroundImage?.name) {
        console.log('→ Atualizando thumb de página:', videoData.backgroundImage.name);
        await safeUpdateMetadata(videoData.backgroundImage.name, [sourceRef, destRef]);
      }

      // 3.2) todos os PDFs da página
      if (Array.isArray(videoData.pdf)) {
        for (const pdfItem of videoData.pdf) {
          if (pdfItem.name) {
            console.log('→ Atualizando PDF:', pdfItem.name);
            await safeUpdateMetadata(pdfItem.name, [sourceRef, destRef]);
          }
        }
      }
    }

    // 4) Atualizar metadados do backgroundImage do módulo (thumbnail principal)
    if (moduleData?.backgroundImage) {
      console.log("moduleData?.backgroundImage is", moduleData.backgroundImage);
      const fileRef = storageRef(storage, moduleData.backgroundImage.name);

      try {
        const meta = await getMetadata(fileRef);
        const existingCustom = meta.customMetadata || {};
        const usos = existingCustom.usages ? JSON.parse(existingCustom.usages) : [];

        const sourceRef = { categoryId: sourceCategoryId, cardId: sourceCardId };
        const destRef = { categoryId: destinationCategoryId, cardId: newCardId };

        const exists = ref =>
          usos.some(u =>
            u.categoryId === ref.categoryId &&
            u.cardId === ref.cardId
          );

        if (!exists(sourceRef)) usos.push(sourceRef);
        if (!exists(destRef)) usos.push(destRef);

        const newCustom = {
          ...existingCustom,
          usages: JSON.stringify(usos),
        };
        console.log("newCustom is", newCustom);
        await updateMetadata(fileRef, { customMetadata: newCustom });
        console.log('Metadados do módulo atualizados com sucesso:', newCustom);
      } catch (metadataError) {
        console.error('Erro ao atualizar metadados do backgroundImage do módulo:', metadataError);
      }
    }

    console.log("Módulo copiado com sucesso com archived:true e todos os vídeos foram copiados e metadados atualizados.");
  } catch (error) {
    console.error('Erro ao copiar módulo:', error);
    throw error;
  }
}

/**
 * Copia uma página de conteúdo (vídeo) para outro módulo ou categoria.
 *
 * @param {string} sourceCategoryId - ID da categoria de origem.
 * @param {string} sourceCardId - ID do módulo de origem.
 * @param {string} sourceVideoId - ID da página (vídeo) a ser copiada.
 * @param {string} destinationCategoryId - ID da categoria de destino.
 * @param {string|null} destinationCardId - ID do módulo de destino (opcional). Se nulo, será criado um novo módulo para abrigar a página.
 */

export async function copyPage(
  sourceCategoryId,
  sourceCardId,
  sourceVideoId,
  destinationCategoryId,
  destinationCardId = null
) {
  console.log('== copyPage START ==');
  console.log({ sourceCategoryId, sourceCardId, sourceVideoId, destinationCategoryId, destinationCardId });

  try {
    // 1) Ler dados da página original
    const sourcePageRef = doc(
      firestore,
      'categories',
      sourceCategoryId,
      'cards',
      sourceCardId,
      'videos',
      sourceVideoId
    );
    const sourcePageSnap = await getDoc(sourcePageRef);
    if (!sourcePageSnap.exists()) {
      throw new Error('Página (vídeo) não encontrada.');
    }
    const pageData = sourcePageSnap.data();
    console.log('pageData carregado:', pageData);

    // 2) Decidir qual cardId usar
    const newVideoId = firestoreAutoId();
    let actualCardId = destinationCardId;
    if (!actualCardId) {
      actualCardId = firestoreAutoId();
      const newModuleData = {
        title: pageData.title ? `${pageData.title} (Cópia)` : 'Novo Módulo - Página Copiada',
        order: 0,
        archived: false,
      };
      await setDoc(
        doc(firestore, 'categories', destinationCategoryId, 'cards', actualCardId),
        newModuleData,
        { merge: true }
      );
      console.log('✔ Novo módulo criado:', actualCardId);
    }
    console.log('actualCardId usado:', actualCardId);

    // 3) Copiar o documento da página
    await setDoc(
      doc(
        firestore,
        'categories',
        destinationCategoryId,
        'cards',
        actualCardId,
        'videos',
        newVideoId
      ),
      pageData,
      { merge: true }
    );
    console.log(`✔ Página copiada para ${destinationCategoryId}/${actualCardId}/${newVideoId}`);

    // 4) Preparar refs e storage
    const storage = getStorage();
    const sourceRef = {
      categoryId: sourceCategoryId,
      cardId: sourceCardId,
      videoId: sourceVideoId
    };
    const destRef = {
      categoryId: destinationCategoryId,
      cardId: actualCardId,
      videoId: newVideoId
    };
    console.log('sourceRef:', sourceRef);
    console.log('destRef:', destRef);

    // helper com logs internos
    async function safeUpdateMetadata(path, refs) {
      console.log(`\n[safeUpdateMetadata] iniciando para: "${path}"`);
      try {
        const fileRef = storageRef(storage, path);
        console.log('[safeUpdate] storageRef criado');

        const meta = await getMetadata(fileRef);
        console.log('[safeUpdate] getMetadata.customMetadata:', meta.customMetadata);

        const existingCustom = meta.customMetadata || {};
        const usos = existingCustom.usages ? JSON.parse(existingCustom.usages) : [];
        console.log('[safeUpdate] usos iniciais:', usos);

        const exists = r =>
          usos.some(u =>
            u.categoryId === r.categoryId &&
            u.cardId === r.cardId &&
            u.videoId === r.videoId
          );

        refs.forEach(r => {
          console.log('[safeUpdate] verifica se existe', r, '=>', exists(r));
          if (!exists(r)) {
            usos.push(r);
            console.log('[safeUpdate] adicionou ref:', r);
          }
        });

        console.log('[safeUpdate] usos finais:', usos);
        const newCustom = {
          ...existingCustom,
          usages: JSON.stringify(usos),
        };
        console.log('[safeUpdate] newCustom que será enviado:', newCustom);

        await updateMetadata(fileRef, { customMetadata: newCustom });
        console.log(`[safeUpdate] updateMetadata OK para "${path}"`);
      } catch (err) {
        console.error(`[safeUpdate] ERRO em "${path}":`, err);
      }
    }

    // 4.1) thumbnail da página
    if (pageData?.backgroundImage?.name) {
      console.log('→ Processando backgroundImage:', pageData.backgroundImage);
      await safeUpdateMetadata(pageData.backgroundImage.name, [sourceRef, destRef]);
    } else {
      console.log('→ Sem backgroundImage nesta página.');
    }

    // 4.2) todos os PDFs
    if (Array.isArray(pageData.pdf)) {
      console.log(`→ Encontrados ${pageData.pdf.length} PDF(s):`, pageData.pdf);
      for (const [i, pdfItem] of pageData.pdf.entries()) {
        console.log(`→ PDF[${i}] item:`, pdfItem);
        if (pdfItem.name) {
          console.log(`   → Processando PDF name="${pdfItem.name}", url="${pdfItem.url}"`);
          await safeUpdateMetadata(pdfItem.name, [sourceRef, destRef]);
        } else {
          console.log(`PDF[${i}] sem campo name, pulando.`);
        }
      }
    } else {
      console.log('→ campo pdf não é array ou ausente.');
    }

    console.log('\n== copyPage END ==');
  } catch (error) {
    console.error('Erro ao copiar página:', error);
    throw error;
  }
}
